import {
  CARE_QUALITY,
  CARE_QUALITY_INTERNAL,
  CLAIMS_METRICS,
  CUSTOM_QUERY_BUILDER,
  DISEASE_PRELAVENCE,
  DISEASE_PRELAVENCE_BY_CONDITION,
  CHRONIC_PREVALENCE,
  CHRONIC_PREVALENCE_BY_CONDITION,
  ENROLLMENT_METRICS,
  EPISODES_OF_CARE,
  EPISODES_OF_CARE_SELECTED,
  ERROR,
  HIGH_COST_CLAIMS,
  HOME_ROUTE,
  HOME_SCREEN,
  LOGIN,
  LOGIN_CALLBACK,
  LOGIN_REDIRECT,
  MED_PHARMA,
  MEMBER_SUMMARY,
  NETWORK_LEAKAGE,
  OTHER_PRESCRIPTION,
  PATIENT_ADMISSION,
  PATIENT_DETAILS,
  PENDING_CLAIMS,
  PLAN_PERFORMANCE,
  PROCEDURE_UTILIZATION,
  PROVIDER_UTILIZATION,
  REJECTED_CLAIMS,
  REPORTS,
  REPORT_PLAN,
  RESET_PASSWORD,
  RISING_RISK,
  RISING_RISK_DETAILS,
  RISK_PATIENT_DETAILS,
  RX_UTILIZATION,
  SETTINGS,
  SIGNUP,
  SPECIALITY_DRUGS,
  STOPLOSS_TRIGGERS,
  SUMMARY,
  USER_MANAGEMENT,
  UTILIZATION_METRICS,
  WASTE_CALCULATOR,
  WASTE_CALCULATOR_DETAILS,
  SPECIFIC_DEDUCTIBLE_CORRIDORS,
  KPI_TRACKER,
  KPI_TRACKER_INTERNAL,
  ONBOARDING,
  CONTRACT_RISK_ANALYSIS,
  CONTRACT_AIQ_INTERNAL,
  CONTRACT_AIQ,
  CONTRACT_AIQ_REPORTS,
  PLAYBOOK,
  PROFILE,
  ACCESS_DASHBOARD,
  ACCESS_DASHBOARD_INTERNAL,
  COMPLIANCE_ASSURANCE,
  PLAN_DOCUMENTS_INTERNAL,
  CUSTOM_ANALYSIS,
  RECOMMENDATIONS,
  CLAIM_ANALYSIS,
  TASK_BOARD,
  COMPLIANCE_REPORT,
  PLAYBOOK_INTERNAL_PAGE,
  PLAYBOOK_DETAILS,
  GAG_CLAUSE_REPORT,
  GAG_CLAUSE_COMPLIANCE,
  REGULATORY_COMPLIANCE_REPORT,
  PURCHASING_STANDARDS_REPORT,
  COMPENSATION_TRANSPARENCY_REPORT,
  CUSTOM_QUERY_INTERNAL,
  INTER_CONTRACT_REPORT,
  REPORTS_PPT,
  RISK_PROFILING_BY_CHRONIC,
  RISK_PROFILING_BY_TRIGGER,
  RISK_PROFILING_BY_COST,
  RISK_PROFILING_BY_UTILIZATION,
  GLP_DRUGS,
  STOPLOSS_REPORT,
  CHRONIC_COHORT,
  HIGH_COST_COHORT,
  MULTIPLE_DRUG_COHORT,
  RISK_PROFILING_BY_DRUGS,
  MEMBER_LIST,
  CONTRACT_ONBOARDING,
  SAVINGS_UTILIZATION,
  DATA_CATALOGUE,
  MERGE_DOCUMENTS,
  PATIENT_CASES,
  CARE_NAVIGATOR,
  CARE_NAVIGATOR_PROFILE,
  TICKET_MANAGEMENT,
  STOPLOSS_TRIGGERS_INTERNAL,
  DRAFT_AGREEMENTS,
  DRAFT_SELECTED,
  PLAN_DOCUMENTS,
  MA_DUE_DILIGENCE,
  MA_DUE_DILIGENCE_INTERNAL,
  MA_DUE_DILIGENCE_ADD,
  RISK_REGISTER,
  ONBOARDINGSTATUS,
  DOC_COMPARISON,
  NEW_DOC_COMPARISON,
  DOC_COMP_INTEGRAL,
  EXPERICENCE_SCREEN,
  ALL_INSIGHTS_NOTIFICATION,
  FINANCIAL_FORENSICS,
  SCENARIO_WORKSPACE,
  SCENARIO_LIBRARY,
  RECONCILIATION_LIBRARY,
  RECONCILIATION_WORKSPACE,
  DEEP_DIVE,
  TERM_COMPILER,
  NEW_TERM_COMPILER,
  TERM_COMPILER_INTERNAL,
  ALL_REPORTS,
  CLAIMS_LIST,
  TREND_ANALYSIS,
  TREND_ANALYSIS_INTERNAL,
  ANNUAL_RENEWAL_PROCESS,
  RENEWAL_DETAILS,
  PLAYBOOK_AND_STANDARD,
  PLAYBOOK_AND_STANDARD_INTERNAL,
  PAYMENT_INTEGRITY,
  PAYMENT_INTEGRITY_INTERNAL,
  CMS_BENCHMARK,
  CMS_BENCHMARK_INTERNAL,
  CHAT,
  COHORT_COMPARISON,
  COHORT_COMPARISON_INTERNAL,
  PROPOSAL_ANALYZER,
} from './routes';

export const allRoutes = [
  HOME_ROUTE,
  LOGIN,
  HOME_SCREEN,
  LOGIN_REDIRECT,
  LOGIN_CALLBACK,
  SIGNUP,
  REPORTS,
  ALL_REPORTS,
  REPORTS_PPT,
  PATIENT_DETAILS,
  SUMMARY,
  DISEASE_PRELAVENCE,
  DISEASE_PRELAVENCE_BY_CONDITION,
  CHRONIC_PREVALENCE,
  CHRONIC_PREVALENCE_BY_CONDITION,
  RISING_RISK,
  RISING_RISK_DETAILS,
  CARE_QUALITY,
  CARE_QUALITY_INTERNAL,
  HIGH_COST_CLAIMS,
  STOPLOSS_TRIGGERS,
  STOPLOSS_TRIGGERS_INTERNAL,
  REPORT_PLAN,
  PLAN_PERFORMANCE,
  CLAIMS_METRICS,
  ENROLLMENT_METRICS,
  PENDING_CLAIMS,
  REJECTED_CLAIMS,
  NETWORK_LEAKAGE,
  UTILIZATION_METRICS,
  PATIENT_ADMISSION,
  RX_UTILIZATION,
  PROCEDURE_UTILIZATION,
  PROVIDER_UTILIZATION,
  USER_MANAGEMENT,
  MEMBER_SUMMARY,
  RISK_PATIENT_DETAILS,
  EPISODES_OF_CARE,
  EPISODES_OF_CARE_SELECTED,
  MED_PHARMA,
  SPECIALITY_DRUGS,
  OTHER_PRESCRIPTION,
  ERROR,
  SETTINGS,
  RESET_PASSWORD,
  WASTE_CALCULATOR,
  WASTE_CALCULATOR_DETAILS,
  SPECIFIC_DEDUCTIBLE_CORRIDORS,
  KPI_TRACKER,
  KPI_TRACKER_INTERNAL,
  CONTRACT_RISK_ANALYSIS,
  ONBOARDING,
  ONBOARDINGSTATUS,
  CONTRACT_AIQ,
  CONTRACT_AIQ_INTERNAL,
  CONTRACT_AIQ_REPORTS,
  PLAYBOOK,
  PROFILE,
  ACCESS_DASHBOARD,
  ACCESS_DASHBOARD_INTERNAL,
  COMPLIANCE_ASSURANCE,
  PLAN_DOCUMENTS,
  PLAN_DOCUMENTS_INTERNAL,
  CUSTOM_ANALYSIS,
  CUSTOM_QUERY_BUILDER,
  RECOMMENDATIONS,
  CLAIM_ANALYSIS,
  TASK_BOARD,
  COMPLIANCE_REPORT,
  PLAYBOOK_INTERNAL_PAGE,
  PLAYBOOK_DETAILS,
  GAG_CLAUSE_REPORT,
  GAG_CLAUSE_COMPLIANCE,
  REGULATORY_COMPLIANCE_REPORT,
  PURCHASING_STANDARDS_REPORT,
  COMPENSATION_TRANSPARENCY_REPORT,
  CUSTOM_QUERY_INTERNAL,
  INTER_CONTRACT_REPORT,
  RISK_PROFILING_BY_CHRONIC,
  RISK_PROFILING_BY_TRIGGER,
  RISK_PROFILING_BY_COST,
  RISK_PROFILING_BY_UTILIZATION,
  GLP_DRUGS,
  STOPLOSS_REPORT,
  CHRONIC_COHORT,
  HIGH_COST_COHORT,
  MULTIPLE_DRUG_COHORT,
  MEMBER_LIST,
  RISK_PROFILING_BY_DRUGS,
  CONTRACT_ONBOARDING,
  SAVINGS_UTILIZATION,
  DATA_CATALOGUE,
  MERGE_DOCUMENTS,
  CARE_NAVIGATOR,
  PATIENT_CASES,
  CARE_NAVIGATOR_PROFILE,
  TICKET_MANAGEMENT,
  DRAFT_AGREEMENTS,
  DRAFT_SELECTED,
  MA_DUE_DILIGENCE,
  MA_DUE_DILIGENCE_INTERNAL,
  MA_DUE_DILIGENCE_ADD,
  DOC_COMPARISON,
  NEW_DOC_COMPARISON,
  DOC_COMP_INTEGRAL,
  RISK_REGISTER,
  EXPERICENCE_SCREEN,
  ALL_INSIGHTS_NOTIFICATION,
  FINANCIAL_FORENSICS,
  SCENARIO_WORKSPACE,
  SCENARIO_LIBRARY,
  RECONCILIATION_WORKSPACE,
  RECONCILIATION_LIBRARY,
  DEEP_DIVE,
  TERM_COMPILER,
  NEW_TERM_COMPILER,
  TERM_COMPILER_INTERNAL,
  CLAIMS_LIST,
  TREND_ANALYSIS,
  TREND_ANALYSIS_INTERNAL,
  ANNUAL_RENEWAL_PROCESS,
  RENEWAL_DETAILS,
  PLAYBOOK_AND_STANDARD,
  PLAYBOOK_AND_STANDARD_INTERNAL,
  PAYMENT_INTEGRITY,
  PAYMENT_INTEGRITY_INTERNAL,
  CMS_BENCHMARK,
  CMS_BENCHMARK_INTERNAL,
  CHAT,
  COHORT_COMPARISON,
  COHORT_COMPARISON_INTERNAL,
  PROPOSAL_ANALYZER,
];

export const basicRoutes = [
  HOME_ROUTE,
  LOGIN,
  HOME_SCREEN,
  LOGIN_REDIRECT,
  LOGIN_CALLBACK,
  SIGNUP,
  REPORTS,
  ALL_REPORTS,
  SETTINGS,
  RESET_PASSWORD,
  CUSTOM_QUERY_BUILDER,
  ONBOARDING,
  ONBOARDINGSTATUS,
  PROFILE,
  DATA_CATALOGUE,
  TICKET_MANAGEMENT,
  RISK_REGISTER,
  TASK_BOARD,
  CHAT,
];

export const routesInFeatures = [
  EXPERICENCE_SCREEN,
  ACCESS_DASHBOARD,
  COMPLIANCE_ASSURANCE,
  CUSTOM_ANALYSIS,
  // REPORTS,
  ALL_REPORTS,
  RECOMMENDATIONS,
  DATA_CATALOGUE,
];
